// Import necessary React components and libraries
import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
} from "reactstrap";
import App from "../App.css";
import TradingGrid from "./TradingGrid";
import ResultsTable from "./ResultsTable";
import { instrumentInfo } from "../utils/InstrumentInfo";

// Define the main functional component for the risk management tool
const RiskManagementTool = () => {
  // State to manage user inputs
  const [formData, setFormData] = useState({
    accountSize: 100000,
    riskPercentage: 3,
    currencyPair: Object.keys(instrumentInfo)[0], // Set default value
    rangeSize: 200,
    desiredProfit: 500,
    accountBalanceCurrency: "USD",
  });

  const [formSubmitted, setFormSubmitted] = useState(false);
  const [showSummary, setShowSummary] = useState(false);

  // Additional state for trade distances and lot sizes
  const [tradeDistances, setTradeDistances] = useState([50, 100, 70, 120, 90]);
  const [lotSizes, setLotSizes] = useState([0.01, 0.02, 0.03, 0.04, 0.05]);
  const riskAmount = 1000; // need to be changed

  useEffect(() => {
    if (formSubmitted) {
      // Your logic to handle form submission
      // Set formSubmitted back to false after processing if needed
      setFormSubmitted(false);
    }
  }, [formSubmitted]);

  // Function to handle form submissions
  const handleSubmit = (e) => {
    e.preventDefault();
    // Implement your form data state accordingly
    setFormData(formData);
    setFormSubmitted(true); // Set formSubmitted to true on submit
    setShowSummary(true);
  };
  return (
    <Container className="app-container">
      <h1>Risk Management Tool</h1>
      <Row className="input-container">
        <Col>
          {/* Input fields for user parameters */}
          <Form onSubmit={handleSubmit}>
            <FormGroup>
              <Label for="accountSize">Account Size:</Label>
              <Input
                type="number"
                id="accountSize"
                value={formData.accountSize}
                onChange={(e) =>
                  setFormData({ ...formData, accountSize: e.target.value })
                }
              />
            </FormGroup>

            <FormGroup>
              <Label for="accountBalanceCurrency">
                Account Balance Currency:
              </Label>
              <Input
                type="select"
                id="accountBalanceCurrency"
                value={formData.accountBalanceCurrency}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    accountBalanceCurrency: e.target.value,
                  })
                }
              >
                <option value="USD">USD</option>
                {/* <option value="EUR">EUR</option>
                <option value="GBP">GBP</option> */}
                {/* Add more currency options as needed */}
              </Input>
            </FormGroup>

            <FormGroup>
              <Label for="riskPercentage">Risk Percentage (%):</Label>
              <Input
                type="number"
                id="riskPercentage"
                value={formData.riskPercentage}
                onChange={(e) =>
                  setFormData({ ...formData, riskPercentage: e.target.value })
                }
              />
            </FormGroup>

            <FormGroup>
              <Label for="instrument">Select Instrument:</Label>
              <Input
                type="select"
                id="instrument"
                value={formData.currencyPair}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    currencyPair: e.target.value,
                  })
                }
              >
                {Object.keys(instrumentInfo).map((instrument) => (
                  <option key={instrument} value={instrument}>
                    {instrument}
                  </option>
                ))}
              </Input>
            </FormGroup>

            <FormGroup>
              <Label for="rangeSize">Range Size (in pips):</Label>
              <Input
                type="number"
                id="rangeSize"
                value={formData.rangeSize}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    rangeSize: e.target.value,
                  })
                }
              />
            </FormGroup>

            {/* <FormGroup>
              <Label for="desiredProfit">Desired Profit:</Label>
              <Input
                type="number"
                id="desiredProfit"
                value={formData.desiredProfit}
                onChange={(e) =>
                  setFormData({ ...formData, desiredProfit: e.target.value })
                }
              />
            </FormGroup> */}

            {/* Submit button */}
            <Button color="primary" type="submit">
              SIMULATE
            </Button>
          </Form>
        </Col>
      </Row>

      <Row className="chart-container">
        <Col>
          {/* Display form data as a visual cue */}
          {showSummary && (
            <div style={{ textAlign: "center" }}>
              <h2>Summary Data</h2>
              <p>Account Size: {formData.accountSize}</p>
              <p>Risk Percentage: {formData.riskPercentage}%</p>
              <p>Account Balance Currency: {formData.accountBalanceCurrency}</p>
              <p>Selected Instrument: {formData.currencyPair}</p>
              <p>Range Size: {formData.rangeSize} pips</p>
              {/* Add more lines for other form data */}
            </div>
          )}

          {/* Chart component */}
          {/* Include your chart component here */}
        </Col>
        {/* <Col> */}
        {/* Chart component */}

        {/* </Col> */}
      </Row>

      {/* Canvas for drawing the trading grid */}
      <Row>
        <Col>
          {/* TradingGrid component */}
          {/* <TradingGrid
            tradeDistances={tradeDistances}
            lotSizes={lotSizes}
            riskAmount={riskAmount}
          /> */}
        </Col>
      </Row>

      <Row>
        <Col>
          {/* Results Table */}
          <ResultsTable formData={formData} formSubmitted={formSubmitted} />
        </Col>
      </Row>

      <Row>
        <Col>
          {/* Display summary of user inputs and calculated results */}
          {/* <h2>Summary</h2> */}
          {/* <p>Account Size: {formData.accountSize}</p> */}
          {/* Add similar lines for other parameters */}
          {/* ... */}
          {/* <p>Calculated Result: // Your calculated result here</p> */}
        </Col>
      </Row>
    </Container>
  );
};

export default RiskManagementTool;
